import React from "react";
import store from "@formApp/store";
import {useFormikContext} from "formik";

export default () => {
  const {errors, touched} = useFormikContext();
  const {formErrors} = React.useContext(store);
  return (
      <section className='formSection formErrors'>
        <div className='formGroup error'>
          {Object.keys(errors).map((key, i) => {
            return (key !== 'termsAcceptance' && key !== 'g-recaptcha-response') // last error is already visible
              ? touched[key] && <div key={i} className="errorMessage">{errors[key]}</div>
              : null
            }
          )}
        </div>
        {formErrors.list.length > 0 &&
        <div className="formGroup error serverErrors">
          {formErrors.list.map((err, i) => {
            return (
              <div key={i} className="errorMessage">
                <div dangerouslySetInnerHTML={{__html: err}} />
              </div>
            )
          })}
        </div>
        }
      </section>
  )
}